"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var isNumeric = function (num) { return (typeof (num) === 'number' || (typeof (num) === "string" && num.trim() !== '')) && !isNaN(num); };
var parseEnvDefault = function (envVal, country) {
    var _a;
    if (envVal === null || envVal === void 0 ? void 0 : envVal.includes("=")) {
        return (_a = envVal.split(",").find(function (v) { return v.split("=", 1)[0] === country; })) === null || _a === void 0 ? void 0 : _a.split("=", 2)[1];
    }
    return envVal;
};
function getUrlParams() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    var invalidParams = [];
    console.log("Env:", process.env);
    var params = new URLSearchParams(window.location.search);
    var locale = params.get("locale") || process.env.REACT_APP_BRP_DEFAULT_LOCALE || "en-CA";
    var country = locale.replace('_', '-').split('-')[1];
    var userregion = params.get("userregion") || (locale.toUpperCase() === "FR-CA" ? "CA-QC" : "");
    var currency = params.get("currency") || "";
    var debug = false;
    var light = false;
    var api = parseInt(params.get('api') || "2");
    var localstream = params.get("localstream");
    var byo_flow = params.get("byo_flow") || "none_passed";
    var buildid = params.get("buildid");
    var profile = params.get("profile") || process.env.REACT_APP_BRP_DEFAULT_PROFILE || "BRP_SSV";
    var platform = params.get("platform") || process.env.REACT_APP_BRP_DEFAULT_PLATFORM || "ssv_defender";
    if (platform.length === 0 || platform.indexOf("_") < 0) {
        invalidParams.push("platform");
    }
    var packageid = params.get("package") || process.env.REACT_APP_BRP_DEFAULT_PACKAGE || "4x4_std";
    if (packageid.length === 0) {
        invalidParams.push("packageid");
    }
    var unitid = params.get("unitid") || undefined;
    var requiredFeatures = __spreadArrays(params.getAll("requiredfeature"), (((_a = params.get("requiredfeatures")) === null || _a === void 0 ? void 0 : _a.split(",")) || []));
    var desiredFeatures = __spreadArrays(params.getAll("desiredfeature"), (((_b = params.get("desiredfeatures")) === null || _b === void 0 ? void 0 : _b.split(",")) || []));
    var desiredAccessories = __spreadArrays(params.getAll("desiredaccessory"), (((_c = params.get("desiredaccessories")) === null || _c === void 0 ? void 0 : _c.split(",")) || []));
    var modelyear = params.get("modelyear") || process.env.REACT_APP_BRP_DEFAULT_MODELYEAR || "2021";
    if (modelyear.length > 0 && !isNumeric(modelyear)) { // might not want the numeric check but handy to test
        invalidParams.push("modelyear");
    }
    //Filthy hack to work around BRP inability to pass the correct url parameters.
    if (platform.toLowerCase().startsWith("ssv_commander") && modelyear === "2021") {
        modelyear = "2020";
    }
    var brand = params.get("brand") || process.env.REACT_APP_BRP_BRAND;
    var shortcode = params.get("shortcode") || undefined;
    if (shortcode) {
        if (shortcode.length < 6 || shortcode.length > 12) {
            invalidParams.push("shortcode");
            shortcode = undefined;
        }
    }
    var env = params.get("env");
    if (env && env.length < 2) {
        invalidParams.push("env");
    }
    var region = params.get("region");
    if (region && region.length < 2) {
        invalidParams.push("region");
    }
    var sw = params.get("sw");
    var flycam;
    var onlyvis = false;
    var metadataOverrideLocation = params.get("metadataOverrideLocation");
    var nofx = false;
    var capturediv = false;
    var nostretch = false;
    var doreconnects = false;
    var autocam = params.get("autocam");
    if (autocam === null) {
        autocam = "smooth";
    }
    else if (autocam === "false") {
        autocam = null;
    }
    if (params.has("flycam")) {
        var value = params.get("flycam");
        flycam = (value === "true" || value === "");
    }
    else {
        flycam = (env !== null && env.indexOf("assetpreview") >= 0);
    }
    if (params.has("onlyvis")) {
        var value = params.get("onlyvis");
        onlyvis = (value === "true" || value === "");
    }
    //else {
    //    onlyvis = (env !== null && env.indexOf("assetpreview") >=0);
    //}
    if (params.has("debug")) {
        var value = params.get("debug");
        debug = (value === "true" || value === "");
    }
    else {
        debug = (env !== null && env.indexOf("assetpreview") >= 0);
    }
    if (params.has("light")) {
        var value = params.get("light");
        light = (value === "true" || value === "");
    }
    if (params.has("nofx")) {
        var value = params.get("nofx");
        nofx = (value === "true" || value === "");
    }
    if (params.has("capturediv")) {
        var value = params.get("capturediv");
        capturediv = (value === "true" || value === "");
    }
    if (params.has("nostretch")) {
        var value = params.get("nostretch");
        nostretch = (value === "true" || value === "");
    }
    if (params.has("doreconnects")) {
        var value = params.get("doreconnects");
        doreconnects = (value === "true" || value === "");
    }
    var screenshotFormat = params.get("screenshotFormat");
    var screenshotSize = 0;
    if (params.has("screenshotSize")) {
        switch (params.get("screenshotSize")) {
            case "720p":
                screenshotSize = 1280;
                break;
            case "1080p":
                screenshotSize = 1920;
                break;
            case "4k":
                screenshotSize = 3840;
                break;
            default:
                try {
                    screenshotSize = parseInt(params.get("screenshotSize"));
                }
                catch (_p) {
                    console.log("Failed to parse resolution from " + params.get("screenshotSize"));
                }
        }
    }
    var hideFinanceOption = locale.endsWith("CA") || ((_d = process.env.REACT_APP_HIDE_FINANCE) === null || _d === void 0 ? void 0 : _d.split(",").includes(country)) || false;
    if (params.has("hideFinanceOption")) {
        var value = params.get("hideFinanceOption");
        hideFinanceOption = (value === "true" || value === "");
    }
    var envDefaultFinanceRate = parseEnvDefault(process.env.REACT_APP_DEFAULT_FINANCE_RATE, country);
    var defaultFinanceRate = isNumeric(envDefaultFinanceRate) ? parseFloat(envDefaultFinanceRate) : 4.99;
    if (isNumeric(params.get("defaultFinanceRate"))) {
        defaultFinanceRate = parseFloat(params.get("defaultFinanceRate"));
    }
    var envDefaultFinancePeriod = parseEnvDefault(process.env.REACT_APP_DEFAULT_FINANCE_PERIOD, country);
    var defaultFinancePeriod = isNumeric(envDefaultFinancePeriod) ? parseFloat(envDefaultFinancePeriod) : 60;
    if (isNumeric(params.get("defaultFinancePeriod"))) {
        defaultFinancePeriod = parseFloat(params.get("defaultFinancePeriod"));
    }
    var availableFinancePeriods = [12, 24, 36, 48, 60];
    var envAvailableFinancePeriods = (_f = (_e = parseEnvDefault(process.env.REACT_APP_AVAILABLE_FINANCE_PERIODS, country)) === null || _e === void 0 ? void 0 : _e.split(";").map(function (p) { return parseInt(p); }).filter(function (p) { return isNumeric(p); })) === null || _f === void 0 ? void 0 : _f.sort();
    if (envAvailableFinancePeriods === null || envAvailableFinancePeriods === void 0 ? void 0 : envAvailableFinancePeriods.length) {
        availableFinancePeriods = envAvailableFinancePeriods;
    }
    if (params.has("availableFinancePeriods")) {
        var argAvailableFinancePeriods = (_h = (_g = params.get("availableFinancePeriods")) === null || _g === void 0 ? void 0 : _g.split(",").map(function (p) { return parseInt(p); }).filter(function (p) { return isNumeric(p); })) === null || _h === void 0 ? void 0 : _h.sort();
        if (argAvailableFinancePeriods === null || argAvailableFinancePeriods === void 0 ? void 0 : argAvailableFinancePeriods.length) {
            availableFinancePeriods = argAvailableFinancePeriods;
        }
    }
    if (!availableFinancePeriods.includes(defaultFinancePeriod)) {
        console.error("Default finance period not one of the available values, defaulting to the largest available period");
        defaultFinancePeriod = availableFinancePeriods[availableFinancePeriods.length - 1];
    }
    var doPreview = false;
    if (params.has("dopreview")) {
        var value = params.get("dopreview");
        doPreview = (value === "true" || value === "");
    }
    var nosharing = true;
    if (params.has("nosharing")) {
        var value = params.get("nosharing");
        nosharing = (value === "true" || value === "");
    }
    var global = params.has("global") && params.get("global") === "true";
    var hideprices = process.env.REACT_APP_HIDE_PRICES === "true" || ((_j = process.env.REACT_APP_HIDE_PRICES) === null || _j === void 0 ? void 0 : _j.split(",").includes(country)) || false;
    if (params.has("hideprices")) {
        var value = params.get("hideprices");
        hideprices = (value === "true" || value === "");
    }
    else if (global)
        hideprices = true;
    var allowmissingnames = false;
    if (params.has("allowmissingnames")) {
        var value = params.get("allowmissingnames");
        allowmissingnames = (value === "true" || value === "");
    }
    var enableerrorreporting = window.location.hostname.includes("-dev") || window.location.hostname.includes("-test") || window.location.hostname.includes("-prerelease");
    if (params.has("enableerrorreporting")) {
        var value = params.get("enableerrorreporting");
        enableerrorreporting = (value === "true" || value === "");
    }
    var ignoreUIBlacklist = false;
    if (params.has("ignoreuiblacklist")) {
        var value = params.get("ignoreuiblacklist");
        ignoreUIBlacklist = (value === "true" || value === "");
    }
    var ignore3DBlacklist = false;
    if (params.has("ignore3dblacklist")) {
        var value = params.get("ignore3dblacklist");
        ignore3DBlacklist = (value === "true" || value === "");
    }
    var force2d = false;
    if (params.has("force2d")) {
        var value = params.get("force2d");
        force2d = (value === "true" || value === "");
    }
    var lazygenerate2d = true;
    if (params.has("lazygenerate2d")) {
        var value = params.get("lazygenerate2d");
        lazygenerate2d = (value === "true" || value === "");
    }
    var forcecachemiss = false;
    if (params.has("forcecachemiss")) {
        var value = params.get("forcecachemiss");
        forcecachemiss = (value === "true" || value === "");
    }
    var contentdamorigin = params.get("contentdamorigin");
    var comingsoon = undefined;
    if (params.has("comingsoon")) {
        var value = params.get("comingsoon");
        comingsoon = (value === "true" || value === "");
    }
    var alternateView = process.env.REACT_APP_ALTERNATE_VIEW === "true" || ((_l = (_k = process.env.REACT_APP_ALTERNATE_VIEW) === null || _k === void 0 ? void 0 : _k.split(",")) === null || _l === void 0 ? void 0 : _l.includes(country)) || false;
    if (params.has("alternateView")) {
        var value = params.get("alternateView");
        alternateView = (value === "true" || value === "");
    }
    var promotion = process.env.REACT_APP_PROMOTION === "true" || ((_o = (_m = process.env.REACT_APP_PROMOTION) === null || _m === void 0 ? void 0 : _m.split(",")) === null || _o === void 0 ? void 0 : _o.includes(country)) || false;
    if (params.has("promotion")) {
        var value = params.get("promotion");
        promotion = (value === "true" || value === "");
    }
    var useRelativeZoom = false;
    if (params.has("useRelativeZoom")) {
        var value = params.get("useRelativeZoom");
        useRelativeZoom = (value === "true" || value === "");
    }
    var showsearch = false;
    if (params.has("showsearch")) {
        var value = params.get("showsearch");
        showsearch = (value === "true" || value === "");
    }
    var apidatasource = params.get("apidatasource") || undefined;
    var shortcodeservice = params.get("shortcodeservice") || undefined;
    var rooturl = params.get("rooturl") || undefined;
    var cas = params.get("cas") || undefined;
    var mainDomain = params.get("mainDomain") || undefined;
    var customer = params.get("customer") || undefined;
    var obj = {
        locale: locale,
        userregion: userregion,
        currency: currency,
        debug: debug,
        light: light,
        api: api,
        localstream: localstream,
        byo_flow: byo_flow,
        buildid: buildid,
        profile: profile,
        platform: platform.toLowerCase(),
        package: packageid.toLowerCase(),
        modelyear: modelyear,
        unitid: unitid,
        requiredFeatures: requiredFeatures,
        desiredFeatures: desiredFeatures,
        desiredAccessories: desiredAccessories,
        brand: brand,
        shortcode: shortcode,
        env: env,
        region: region,
        sw: sw,
        flycam: flycam,
        onlyvis: onlyvis,
        metadataOverrideLocation: metadataOverrideLocation,
        nofx: nofx,
        capturediv: capturediv,
        autocam: autocam,
        screenshotFormat: screenshotFormat,
        screenshotSize: screenshotSize,
        nostretch: nostretch,
        doreconnects: doreconnects,
        invalidParams: invalidParams,
        hideFinanceOption: hideFinanceOption,
        defaultFinanceRate: defaultFinanceRate,
        defaultFinancePeriod: defaultFinancePeriod,
        availableFinancePeriods: availableFinancePeriods,
        doPreview: doPreview,
        nosharing: nosharing,
        hideprices: hideprices,
        allowmissingnames: allowmissingnames,
        enableerrorreporting: enableerrorreporting,
        ignoreUIBlacklist: ignoreUIBlacklist,
        ignore3DBlacklist: ignore3DBlacklist,
        force2d: force2d,
        lazygenerate2d: lazygenerate2d,
        forcecachemiss: forcecachemiss,
        contentdamorigin: contentdamorigin,
        comingsoon: comingsoon,
        alternateView: alternateView,
        promotion: promotion,
        useRelativeZoom: useRelativeZoom,
        cas: cas,
        mainDomain: mainDomain,
        global: global,
        showsearch: showsearch,
        apidatasource: apidatasource,
        shortcodeservice: shortcodeservice,
        rooturl: rooturl,
        customer: customer
    };
    window.zlurlparams = obj;
}
function canUseFlyCam() {
    return window.zlurlparams.flycam && (window.location.host.includes(":") || window.location.host.includes("-dev") || window.location.host.includes("-test")); // only allow it if its a local stream or were on dev/test
}
exports.canUseFlyCam = canUseFlyCam;
getUrlParams();
//# sourceMappingURL=zlUrlParams.js.map